import { LoginLayout } from 'src/layouts';
import { OneClickAlarmAcknowledgementPage } from '../../pages';

export const AlarmsOneClickAcknowledgementElement = () => (
  <LoginLayout>
    <OneClickAlarmAcknowledgementPage />
  </LoginLayout>
);
